import api from './api';

class AiRfpService {
  static async createDraft(inputPayload, promptConfig = null) {
    const response = await api.post(
      '/rfp/create',
      {
        inputPayload,
        promptConfig,
      },
      { timeout: 120000 },
    );
    return response.data;
  }

  static async generateDraft({ draftId, inputPayload, promptConfig = null }) {
    const response = await api.post(
      '/rfp/generate',
      {
        draftId,
        inputPayload,
        promptConfig,
      },
      { timeout: 120000 },
    );
    return response.data;
  }
}

export default AiRfpService;
